/**
 * @param {object} props
 * @param {import("react").ReactNode} [props.children]
 * @param {string} [props.className]
 * @returns {React.Component}
 */
const GradientBg = ({ children, className }) => {
  return (
    <div
      className={"bg-gradient-to-b from-[#6476EC] to-[#432F85] " + className}
    >
      {children}
    </div>
  );
};

export default GradientBg;
